import { useTranslation } from 'react-i18next';
import Card from '../../../common/Card';
import { TopPriceBlock } from '../../../common/TopPriceBlock';

export const TopCardWrapper = ({
    children,
    topTitle,
    price,
    onPriceClick,
    priceLabel,
    buttonLabel,
    highlighted,
    stacked,
}) => {
    const { t } = useTranslation();
    const extraClass = [
        highlighted && 'card__payments--highlighted',
        stacked && 'card__payments--stacked',
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <Card isTop extraClass={extraClass}>
            {highlighted && (
                <span className="top-badge__ribbon">{t('recommended')}</span>
            )}
            <div className="top-badge__block">
                <div className="top-badge__card">
                    <h3>{topTitle}</h3>
                </div>
                <div className="top-badge__features">{children}</div>
                <TopPriceBlock
                    price={price}
                    onClick={onPriceClick}
                    priceLabel={priceLabel}
                    buttonLabel={buttonLabel}
                />
            </div>
        </Card>
    );
};
